import { init as loginInit } from '../components/loginComponent';
import { init as signupInit } from '../components/signupComponent';
import { init as ugcPhotoUploadInit } from '../components/ugcPhotoUploadComponent';
import { init as informationalModalInit } from '../components/informationalModalComponent';
import { brandModalHashes } from './brandModalHashLauncherConfig';
import { init as userNameInit } from '../components/userNameModalComponent';
import { init as quickshopModalInit } from '../components/quickshopHashModalComponent';
import { init as afterpayInfoModalInit } from '../components/afterpayInfoModalComponent';
import { init as bopisRestrictedModalInit } from '../components/bopisRestrictedModalComponent';

const globalModalHashes = {
    '#email-sign-up': {
        dynamic: true,
        load: (state) => import('@core/js/components/emailSignUpModalComponent')
            .then(({ init }) => ({
                init,
                overrides: {
                    optInSource: _.get(
                        state,
                        'core.featureConfigs.lightboxAnonymousEmailSubscriptions.source',
                        'Lightbox'
                    ),
                    storeLocation: 'modal',
                }
            })
        ),
    },
    '#sign-up': { init: signupInit },
    '#sign-in': { init: loginInit },
    '#order-inquiry': {
        dynamic: true,
        load: () => import('@core/js/components/async/orderStatusComponent')
            .then(({ init }) => ({ init })),
    },
    '#ugc-photo-upload': { init: ugcPhotoUploadInit },
    '#informational': { init: informationalModalInit },
    '#set-user-name': { init: userNameInit },
    '#quickshop': { init: quickshopModalInit },
    '#afterpay-info': { init: afterpayInfoModalInit },
    '#bopis-restricted': { init: bopisRestrictedModalInit },
    '#loyalty-signup': {
        dynamic: true,
        load: () => import('@loyalty/js/components/loyaltyModalComponent')
            .then(({ init }) => ({ init })),
    },
    '#cp-info': {
        dynamic: true,
        load: () => import('@core/js/components/collectionPointsModalComponent')
            .then(({ init }) => ({ init })),
    },
    '#ispu-info': {
        dynamic: true,
        load: () => import('@core/js/components/ispuModalComponent')
                .then(({ init }) => ({ init })),
    },
    '#quickship-info': {
        dynamic: true,
        load: () => import('@core/js/components/quickshipInfoModalComponent')
                .then(({ init }) => ({ init })),
    },
};

export const modalHashes = Object.assign({}, globalModalHashes, brandModalHashes);
